import { render } from "./default-tag.vue?vue&type=template&id=3bfbcc04&lang=pug"
import script from "./default-tag.vue?vue&type=script&setup=true&lang=js"
export * from "./default-tag.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__